import SumInsuredIcon from "../assets/svgs/inclusion_sum_insured.svg";
import RoomLimitIcon from "../assets/svgs/inclusion_room_limit.svg";
import MaternityIcon from "../assets/svgs/inclusion_maternity.svg";
import BabyCoverageIcon from "../assets/svgs/inclusion_baby_coverage.svg";
import WaitingPeriodIcon from "../assets/svgs/inclusion_waiting_period.svg";
import CoPayIcon from "../assets/svgs/inclusion_co_pay.svg";
import OpdIcon from "../assets/svgs/inclusion_opd.svg";
import AmbulanceIcon from "../assets/svgs/inclusion_ambulance.svg";
import HealthCheckupIcon from "../assets/images/marketplace_images/health.png";
import Doctor from "../assets/images/marketplace_images/doctor.png";
import Dental from "../assets/images/marketplace_images/dental.png";
import Mental from "../assets/images/marketplace_images/mental.png";
import Vision from "../assets/images/marketplace_images/vision.png";
import More from "../assets/images/marketplace_images/more.png";

export const FLEX_HEADERS = ["Mandatory", "Voluntary"];

export const CARE_APP_LINKS = {
  ANDROID: "https://play.google.com/store/apps/details?id=com.religare.healthinsurance&hl=en_IN",
  IOS: "https://apps.apple.com/in/app/care-health-customer-app/id1451697831"
}

export const INCLUSIONS = {
  sum_insured: {
    name: "Sum Insured",
    icon: SumInsuredIcon,
  },
  room_limit: {
    name: "Room Limit",
    icon: RoomLimitIcon,
  },
  maternity_coverage: {
    name: "Maternity",
    icon: MaternityIcon,
  },
  baby_coverage: {
    name: "Baby Coverage",
    icon: BabyCoverageIcon,
  },
  disease_wise_limit: {
    name: "Disease-wise Limit",
    icon: SumInsuredIcon,
  },
  co_pay: {
    name: "Co-Pay",
    icon: CoPayIcon,
  },
  waiting_period: {
    name: "Waiting Period",
    icon: WaitingPeriodIcon,
  },
  opd: {
    name: "OPD",
    icon: OpdIcon,
  },
  ambulance_limit: {
    name: "Ambulance Limit",
    icon: AmbulanceIcon,
  },
};

export const PRODUCTS_NAME = {
  "gmc_non_maternity": "Group Health Insurance",
  "gmc_maternity": "Group Health Insurance",
  "health_insurance": "Group Health Insurance",
  "group_personal_accidental": "Group Personal Accident",
  "personal_accident": "Group Personal Accident",
  "group_term_life": "Group Term Life",
  "term_life": "Group Term Life",
  "opd_cover": "OPD Cover",
  "critical_illness": "Critical Illness",
  "health_checkup": "Health Checkup",
  'mandatory_top_up_health': "Mandatory Top Up Health",
  'top_up_health': "Top Up Health",
  'parental_cover': "Parental Cover"
};

export const RELATIONS = {
  SELF: "Self",
  FATHER: "Father",
  MOTHER: "Mother",
  FATHERINLAW: "Father-in-law",
  MOTHERINLAW: "Mother-in-law",
  SPOUSE: "Spouse",
  DAUGHTER : "Daughter",
  SON: "Son",
  SIBLING: "Sibling"
}

export const BUSINESS_DETAILS = {
  CIN: "U66220MH2023PTC415217",
  IRDAI: "932"
}

export const MARKETPLACE_CARDS = [
  {
    name: "Health Checkup",
    image: HealthCheckupIcon,
  },
  {
    name: "Doctor Consultations",
    image: Doctor,
  },
  {
    name: "Mental Wellbeing",
    image: Mental,
  },
  {
    name: "Vision Care",
    image: Vision,
  },
  {
    name: "Dental Care",
    image: Dental,
  },
  {
    name: "And Many More",
    image: More,
  },
];